import styled from "styled-components";

export const WebDevSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10rem auto 5rem auto;
`;

export const ServiceTextSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: left;
  margin: 0;
`;

export const WebDevParagraphIntro = styled.p`
  color: var(--darktext);
  font-weight: 500;
  font-size: 16px;
  margin: 0;
  line-height: 20px;
  max-width: 97%;
  white-space: pre-line;
  padding: 0 20px;

  /* Tablet  */
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 26px;
    max-width: 620px;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 18px;
    line-height: 30px;
    max-width: 700px;
  }
`;

export const WebDevParagraph = styled.p`
  color: var(--darktext);
  font-weight: 300;
  font-size: 16px;
  margin: 20px 0;
  line-height: 20px;
  max-width: 97%;
  white-space: pre-line;
  padding: 0 20px;

  /* Tablet  */
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 26px;
    max-width: 620px;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 18px;
    line-height: 30px;
    max-width: 700px;
  }
`;